import moment from 'moment';

export const formatTime = (time) => {
  if (!time) return '';
  return moment(time).format('HH:mm');
};

export const formatDate = (time) => {
  return time ? time.slice(0, 5) : '';
};

export const calculateDelay = (actualOrEstimatedTime, scheduledTime, scheduledDate) => {
  if (!actualOrEstimatedTime || !scheduledTime || !scheduledDate) return 'NaN';
  const timeToUse = moment(actualOrEstimatedTime);
  const scheduled = moment(`${scheduledDate}T${scheduledTime}`);
  const delayInMinutes = timeToUse.diff(scheduled, 'minutes');
  return delayInMinutes >= 0 ? `+${delayInMinutes}` : `${delayInMinutes}`;
};

export const calculatePlanePosition = (actualRunwayDeparture, estimatedRunwayArrival) => {
  if (!actualRunwayDeparture || !estimatedRunwayArrival) return 0;

  const departureTime = moment(actualRunwayDeparture);
  const arrivalTime = moment(estimatedRunwayArrival);
  const currentTime = moment();

  const totalDuration = arrivalTime.diff(departureTime, 'minutes');
  const elapsed = currentTime.diff(departureTime, 'minutes');

  if (totalDuration <= 0) return 100;
  let position = (elapsed / totalDuration) * 100;
  return position > 100 ? 100 : position;
};

export const calculateProgress = (actualRunwayDeparture, estimatedRunwayArrival) => {
  const position = calculatePlanePosition(actualRunwayDeparture, estimatedRunwayArrival);
  return position > 99 ? 99 : position;
};
